import { render, staticRenderFns } from "./OrderFormDisabled.vue?vue&type=template&id=e6358c40&scoped=true&class=h-full&"
import script from "./OrderFormDisabled.vue?vue&type=script&lang=js&"
export * from "./OrderFormDisabled.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormDisabled.vue?vue&type=style&index=0&id=e6358c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6358c40",
  null
  
)

export default component.exports